const initialState = {
  countryList: []
};

const CountryListReducer = (state = initialState, action) => {
  return action?.type === 'COUNTRY_LIST'
    ? { ...state, countryList: action.payload }
    : state;
};

export default CountryListReducer;
